import { t } from '@lingui/macro';

export interface ControlModeModel {
  component: JSX.Element;
  buttons?: JSX.Element[];
}

export enum ModeSettingsTabsType {
  Off = 'Off',
  ManualFixedOutlet = 'ManualFixedOutlet',
  ManualFlowTable = 'ManualFlowTable',
  ManualTimeTable = 'ManualTimeTable',
  ManualFlowAndTimeTable = 'ManualFlowAndTimeTable',
  Learning = 'Learning',
  Active = 'Active',
}

export const ModeSettingsTabsFn = (): Record<ModeSettingsTabsType, string> => ({
  [ModeSettingsTabsType.Off]: t({ message: 'Off', id: '[ModeSettings.Off]' }),
  [ModeSettingsTabsType.ManualFixedOutlet]: t({
    message: 'Manual Fixed Outlet',
    id: '[ModeSettings.ManualFixedOutlet]',
  }),
  [ModeSettingsTabsType.ManualFlowTable]: t({
    message: 'Manual Flow Table',
    id: '[ModeSettings.ManualFlowTable]',
  }),
  [ModeSettingsTabsType.ManualTimeTable]: t({
    message: 'Manual Time Table',
    id: '[ModeSettings.ManualTimeTable]',
  }),
  [ModeSettingsTabsType.ManualFlowAndTimeTable]: t({
    message: 'Manual Flow & Time Table',
    id: '[ModeSettings.ManualFlowAndTimeTable]',
  }),
  [ModeSettingsTabsType.Learning]: t({
    message: 'Learning',
    id: '[ModeSettings.Learning]',
  }),
  [ModeSettingsTabsType.Active]: t({ message: 'Active', id: '[ModeSettings.Active]' }),
});
